import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow } from "../home/Intro";
import { PostCard } from "./PostCard";
import { usePosts } from "../../lib/posts";

export const LatestNews = () => {
  const posts = usePosts();
  if (!posts || posts.length === 0) return null;
  return (
    <section data-testid="latest-news-section" className="bg-white">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <Eyebrow>News &amp; insights</Eyebrow>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[var(--forest)] mt-6">Latest from our technical team</h2>
          </div>
          <Link to="/news" data-testid="latest-news-all-link" className="inline-flex items-center gap-2 font-bold text-[var(--moss)]">View all insights <ArrowRight size={16} /></Link>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {posts.slice(0, 3).map((p, i) => <PostCard key={p.id} p={p} i={i} />)}
        </div>
      </div>
    </section>
  );
};
